export default "__VITE_ASSET__Cv_SM5fR__"